export function toggleDropdown(selectBox, dropDownArrow) {
  if (selectBox.className === 'hidden') {
    selectBox.setAttribute('class', 'visible');
    dropDownArrow.style.transform = 'rotate(180deg)';
  } else {
    selectBox.setAttribute('class', 'hidden');
    dropDownArrow.style.transform = 'rotate(0deg)';
  }
}

export function selectOption(dropDown, selectBox, dropDownArrow, innerHTML) {
  dropDown.innerHTML = innerHTML;

  selectBox.setAttribute('class', 'hidden');
  dropDownArrow.style.transform = 'rotate(0deg)';

  const url = new URL(window.location.href);

  url.searchParams.set('limit', innerHTML);

  url.searchParams.set('page', '1');

  window.location.href = url.toString();
}
